<template>
  <PortalBlock :portal-block="1"></PortalBlock>
</template>

<script>
import PortalBlock from "./components/PortalBlock.vue";

export default {
  name: "portal-home",
  components: {
    PortalBlock,
  },
};
</script>
